import { action } from 'typesafe-actions';

import { PlayerActionTypes } from './types';

export const setPlayerPlaylistData = (
  playlistId?: string,
  playlistItemId?: string,
) =>
  action(PlayerActionTypes.SET_PLAYLIST_DATA, playlistId, { playlistItemId });

export const Actions = {
  setPlayerPlaylistData,
};
